import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormGroup,
} from "@angular/forms";

export function isStartTimeAfterEndTime(
  startTime: string,
  endTime: string
): boolean {
  const [hours1, minutes1] = startTime.split(":").map(Number);
  const [hours2, minutes2] = endTime.split(":").map(Number);

  if (hours1 > hours2) return true;
  if (hours1 === hours2 && minutes1 > minutes2) return true;

  return false;
}

export function timePairValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const form = group as FormGroup;

    const fromMonday = form.get("fromMonday");
    const toFriday = form.get("toFriday");
    const fromSaturday = form.get("fromSaturday");
    const toSaturday = form.get("toSaturday");
    const fromSunday = form.get("fromSunday");
    const toSunday = form.get("toSunday");

    let hasError = false;

    // Clear previous timePair errors
    [
      fromMonday,
      toFriday,
      fromSaturday,
      toSaturday,
      fromSunday,
      toSunday,
    ].forEach(clearTimePairError);

    // Monday to Friday check
    if (isFilled(fromMonday?.value) && !isFilled(toFriday?.value)) {
      toFriday?.setErrors({ ...(toFriday.errors || {}), timePair: true });
      hasError = true;
    } else if (!isFilled(fromMonday?.value) && isFilled(toFriday?.value)) {
      fromMonday?.setErrors({ ...(fromMonday.errors || {}), timePair: true });
      hasError = true;
    } else if (
      isFilled(fromMonday?.value) &&
      isFilled(toFriday?.value) &&
      isStartTimeAfterEndTime(fromMonday?.value, toFriday?.value)
    ) {
      fromMonday?.setErrors({
        startTimeAfterEndTime: true,
        timePair: true,
      });
      hasError = true;
    }

    // Saturday check
    if (isFilled(fromSaturday?.value) && !isFilled(toSaturday?.value)) {
      toSaturday?.setErrors({ ...(toSaturday.errors || {}), timePair: true });
      hasError = true;
    } else if (!isFilled(fromSaturday?.value) && isFilled(toSaturday?.value)) {
      fromSaturday?.setErrors({
        ...(fromSaturday.errors || {}),
        timePair: true,
      });
      hasError = true;
    } else if (
      isFilled(fromSaturday?.value) &&
      isFilled(toSaturday?.value) &&
      isStartTimeAfterEndTime(fromSaturday?.value, toSaturday?.value)
    ) {
      fromSaturday?.setErrors({
        startTimeAfterEndTime: true,
        timePair: true,
      });
      hasError = true;
    }

    // Sunday check
    if (isFilled(fromSunday?.value) && !isFilled(toSunday?.value)) {
      toSunday?.setErrors({ ...(toSunday.errors || {}), timePair: true });
      hasError = true;
    } else if (!isFilled(fromSunday?.value) && isFilled(toSunday?.value)) {
      fromSunday?.setErrors({ ...(fromSunday.errors || {}), timePair: true });
      hasError = true;
    } else if (
      isFilled(fromSunday?.value) &&
      isFilled(toSunday?.value) &&
      isStartTimeAfterEndTime(fromSunday?.value, toSunday?.value)
    ) {
      fromSunday?.setErrors({
        startTimeAfterEndTime: true,
        timePair: true,
      });
      hasError = true;
    }

    return hasError ? { timePair: true } : null;
  };
}

export function formFieldsHasError(
  fields: string[],
  form: FormGroup,
  error: string
) {
  return fields.some((fieldName) => {
    const field = form.get(fieldName);
    return field?.hasError(error) && field?.touched;
  });
}

// Utility: checks for null, undefined, or empty string
function isFilled(value: any): boolean {
  return value !== null && value !== undefined && value !== "";
}

// Utility: clears only the `timePair` error from a control
function clearTimePairError(control: AbstractControl | null): void {
  if (!control?.errors) return;
  const { timePair, ...otherErrors } = control.errors;
  control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
}
